import { Shark, Utils, View } from "shark-mvc";

import Organization from "../../models/Organization";

import templateContent from "./organization.html";
import "./style.css";

// import acceptInvitationView from "../acceptInvitation/acceptInvitationView";
import activeWorkSessionDisplayComponent from "../../components/activeWorkSessionDisplay/activeWorkSessionDisplayComponent";
import inviteUserComponent from "../../components/inviteUserModal/inviteUserComponent";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import organizationManager from "../../managers/organizationManager";
import organizationMembershipManager from "../../managers/organizationMembershipManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import workSessionDetailsModalComponent from "../../components/workSessionDetailsModal/workSessionDetailsModalComponent";
import organizationUserDetailPanelComponent from "../../components/organizationUserDetailPanel/organizationUserDetailPanelComponent";
import OrganizationMembership from "../../models/OrganizationMembership";
import { Tab } from "bootstrap";
import organizationAddPanelComponent from "../../components/organizationAddPanel/organizationAddPanelComponent";

class OrganizationView extends View {
	constructor () {
		super("organizationView");
		this.setTemplate(templateContent);
	}

	// async addOrganizationBtn_clickHandler () {
	// 	const { currUser, currUserOrganizationMembershipList, organizationList } = Shark.get();

	// 	const currOrganization = new Organization({
	// 		guid: Shark.__generateGUID("temp_"),
	// 		name: Shark.$store.labels.name_new_organization,
	// 		ownerGuid: currUser.guid,
	// 		status: 1,
	// 	});

	// 	organizationList.push(currOrganization);

	// 	let currOrganizationMembership = new OrganizationMembership({
	// 		guid: Shark.__generateGUID(),
	// 		inviteEMail: currUser.email,
	// 		inviteMessage: "",
	// 		organizationGuid: currOrganization.guid,
	// 		role: OrganizationMembership.ROLE_OWNER,
	// 		status: OrganizationMembership.STATUS_ACTIVE,
	// 		userGuid: currUser.guid,
	// 	});
		
	// 	currOrganizationMembership.__organizationName = currOrganization.name;
		
	// 	currUserOrganizationMembershipList.unshift(currOrganizationMembership);
	// 	console.log(currUserOrganizationMembershipList);

	// 	Shark.set({
	// 		currOrganization,
	// 		currOrganizationMembership,
	// 		currUserOrganizationMembershipList,
	// 		organizationList,
	// 	});

	// 	document.querySelector(`[data-guid="`+ currOrganizationMembership.guid +`"]`).click();
	// 	this.enableEdits();
	// }

	beforeLoad () {
		const { currUser } = Shark.get();

		this.updateMenuTitle();

		organizationManager.getByOwnerGuid(currUser.guid)
		.then(async result => {
			// console.log({result});
			let currOrganization;

			if (result.data) {
				currOrganization = result.data;
			}
			else {
				currOrganization = new Organization({
					ownerGuid: currUser.guid,
				});
			}

			// let organizationMembershipList = [];

			// if (currOrganization.guid !== "") {
			// 	const organizationMembershipListResponse = await organizationMembershipManager.getListByOrganizationGuid(currOrganization.guid);
			// 	organizationMembershipList = organizationMembershipListResponse.data;
			// 	organizationMembershipList.forEach(item => {
			// 		item.on("dataChanged", async () => {
			// 			// Dave: Questo dovrebbe succedere da sé, vedendo che "isDirty" è sulla view...
			// 			Shark.render();
			// 		});
			// 	});
			// }
			
			Shark.set({
				currOrganization,
				// organizationMembershipList,
			});

			this.refreshList();
	});
	}

	cancelOrganizationEditsBtn_clickHandler () {
		this.disableEdits();
	}

	disableEdits () {
		Shark.set({
			__isEditingOrganization: false,
			__isEditingOrganizationMembership: false,
		});
	}

	editOrganizationBtn_clickHandler () {
		this.enableEdits();
	}

	enableEdits () {
		Shark.set({
			__isEditingOrganization: Shark.$store.editingOrganization.__currUserCanEdit,
			__isEditingOrganizationMembership: true,
		});
	}

	hideOrganizationDetailsColumnBtn_clickHandler () {
		Shark.$store.organizationDetailColumnCSSClasses = "";
	}

	init () {
		this.addComponents([activeWorkSessionDisplayComponent, inviteUserComponent, mainNavComponent, organizationAddPanelComponent, organizationUserDetailPanelComponent, waitBoxComponent, workSessionDetailsModalComponent]);
		
		Shark.set({
			currOrganization: null,
			isEditingOrganization: null,
			organizationMembershipList: [],
			organizationDetailColumnCSSClasses: "", // Per gestire la colonna dei dettagli dell'organizzazione che slida in mobile
			__isEditingOrganization: false,
			__isEditingOrganizationMembership: false,
		});
	}

	inviteUserComponent_userInvitedHandler (event, data) {
		// console.log({event, data});
		this.refreshOrganizationMemberList();
	}

	organizationUserDetailPanelComponent_userListRefreshNeededHandler (event, data) {
		// console.log({event, data});
		this.refreshOrganizationMemberList();
	}

	async saveMembership (membership) {
		waitBoxComponent.open();
		await organizationMembershipManager.save(membership);
		waitBoxComponent.close();
	}

	async saveUserMembershipBtn_clickHandler (event, data) {
		const { currUserOrganizationMembershipList } = Shark.get();
		const currOrganizationMembership = currUserOrganizationMembershipList.find(item => item.guid === data.guid);
		
		if (currOrganizationMembership) {
			waitBoxComponent.open();
			await organizationMembershipManager.save(currOrganizationMembership);
			waitBoxComponent.close();
		}
	}

	async refreshList () {
		const { currOrganization, organizationList } = Shark.get();
		let organizationMembershipList = [];

		if (currOrganization.guid !== "") {
			const organizationMembershipListResponse = await organizationMembershipManager.getListByOrganizationGuid(currOrganization.guid);
			organizationMembershipList = organizationMembershipListResponse.data;
			organizationMembershipList.forEach(item => {
				item.on("dataChanged", async () => {
					// Dave: Questo dovrebbe succedere da sé, vedendo che "isDirty" è sulla view...
					Shark.render();
				});
			});
		}

		const currUserOrganizationMembershipListResponse = await organizationMembershipManager.getList();
		const currUserOrganizationMembershipList = currUserOrganizationMembershipListResponse.data;

		// Dave: questa roba va fatta "di là"
		currUserOrganizationMembershipList.forEach((membership, index) => {
			const organization = organizationList.find(organization => organization.guid === membership.organizationGuid);
			membership._index = index;
			if (organization) {
				membership.__organizationName = organization.name;
			}
		});

		currUserOrganizationMembershipList.sort((a, b) => {
			if (a.role === OrganizationMembership.ROLE_OWNER && b.role !== OrganizationMembership.ROLE_OWNER) {
				return -1;
			}
			else if (a.role !== OrganizationMembership.ROLE_OWNER && b.role === OrganizationMembership.ROLE_OWNER) {
				return 1;
			}
			else if (a.inviteEMail < b.inviteEMail) {
				return -1;
			}
			else if (a.inviteEMail > b.inviteEMail) {
				return 1;
			}
		});
		// const currUserOrganizatioListResult = organizationManager.getListForCurrentUser();
		// const currUserOrganizatioList = currUserOrganizatioListResult.data;

		// console.log({currUserOrganizationMembershipListResponse});

		Shark.set({
			currUserOrganizationMembershipList,
			organizationMembershipList,
		});
	}

	async refreshOrganizationMemberList () {
		const { editingOrganization } = Shark.get();

		if (editingOrganization) {
			const organizationMembershipResponse = await organizationMembershipManager.getListByOrganizationGuid(editingOrganization.guid);
			// console.log({organizationMembershipResponse});
			
			Shark.set({
				organizationMembershipList: organizationMembershipResponse.data,
			});
		}
	}

	saveMembershipBtn_clickHandler (event, data) {
		const { organizationMembershipList } = Shark.get();
		const currMembership = Utils.safp(organizationMembershipList, "guid", data.guid);

		if (currMembership) {
			this.saveMembership(currMembership);
		}
	}

	async saveOrganization () {
		const { editingOrganization, currOrganizationMembership, __isEditingOrganization, __isEditingOrganizationMembership } = Shark.get();

		if (editingOrganization && currOrganizationMembership) {
			waitBoxComponent.open();

			if (__isEditingOrganization) {
				let isNewOrganization = editingOrganization.guid.slice(0, 5) === "temp_";
				
				if (isNewOrganization) {
					editingOrganization.guid = "";
				}
				
				await organizationManager.save(editingOrganization);
				
				if (isNewOrganization) {
					currOrganizationMembership.set({
						guid: "",
						organizationGuid: editingOrganization.guid
					});
				}
			}

			if (__isEditingOrganizationMembership) {
				await this.saveMembership(currOrganizationMembership);
			}
			
			Shark.set({
				__firstOrganizationToAdd: !Shark.$store.organizationList.lenght > 0,
				__isEditingOrganization: false,
				__isEditingOrganizationMembership: false,
			});
	
			waitBoxComponent.close();
		}
	}

	saveOrganizationBtn_clickHandler () {
		this.saveOrganization();
	}

	async singleOrganizationBtn_clickHandler (event, data) {
		Shark.$store.organizationDetailColumnCSSClasses = "organization-selected";

		const singleOrganizationGuid = data.guid;

		let editingOrganization;
		let currOrganizationMembership;
		const { currUserOrganizationMembershipList, organizationList } = Shark.get();

		currUserOrganizationMembershipList.forEach(item => {
			item._selected = item.guid === singleOrganizationGuid;
			
			if (item._selected) {
				item.__selectedCssClasses = "active";

				editingOrganization = Utils.safp(organizationList, "guid", item.organizationGuid);
				// console.log(editingOrganization);
				// Dave: to organize
				editingOrganization.parseOwner();
				currOrganizationMembership = item;
			}
			else {
				item.__selectedCssClasses = "";
			}
		});

		Shark.set({
			editingOrganization,
		});

		if (!editingOrganization.__currUserCanManageUsers)
		{
			Tab.getOrCreateInstance(document.getElementById("settingsTab")).show();
		}
		
		Shark.set({
			editingOrganization,
			currOrganizationMembership,
			currUserOrganizationMembershipList,
			__isEditingOrganization: false,
		});
		
		this.refreshOrganizationMemberList();
	}

	updateMenuTitle () {
		Shark.set({
			__menuTitle: Shark.$store.labels.organizations,
		});
	}
}

const organizationView = new OrganizationView();

Shark.registerView(organizationView);

export default organizationView;
